
const API_BASE_URL = "https://api.indiahirings.com/admin/subscriptions-topup-employer";
const AUTH = "Bearer 1|qzdKsGqCl4x2vKH2c2b4Qt1Exn6KcIf5QkswXJoH90ca7775";

const defaultHeaders = {
  Accept: "application/json",
  Authorization: AUTH,
  "Content-Type": "application/json",
};

export const fetchSubscriptionTopUp = async () => {
  try {
    const response = await fetch(API_BASE_URL, {
      method: "GET",
      headers: defaultHeaders,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.response?.msg || `HTTP error! Status: ${response.status}`
      );
    }
    const data = await response.json();
    return data.response || [];
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const addSubscriptionTopUp = async (newSubscription) => {
  try {
    const response = await fetch(API_BASE_URL, {
      method: "POST",
      headers: defaultHeaders,
      body: JSON.stringify(newSubscription),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.response?.msg ||
        `Error adding subscription: ${response.statusText}`
      );
    }

    const data = await response.json();

    return data.response || data;
  } catch (error) {
    console.error("Add error:", error);
    throw error;
  }
};

export const updateSubscriptionTopUp = async (id, updateSubscriptiondata) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${id}`, {
      method: "PUT",
      headers: defaultHeaders,
      body: JSON.stringify(updateSubscriptiondata),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.response?.msg || `Error updating: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data.response || data;
  } catch (error) {
    console.error("Update error:", error);
    throw error;
  }
};

export const deleteSubscriptionTopUp = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${id}`, {
      method: "DELETE",
      headers: defaultHeaders,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.response?.msg || `Error deleting: ${response.statusText}`
      );
    }

    return { success: true, id };
  } catch (error) {
    console.error("Delete error:", error);
    throw error;
  }
};

export const fetchEmployerSubscription = async (page = 1) => {
  const url = `https://api.indiahirings.com/admin/subscriptions-details-employer?page=${page}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: defaultHeaders,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return {
      data: data.response.data || [],
      pagination: {
        current_page: data.response.current_page,
        last_page: data.response.last_page,
        total: data.response.total,
      },
    };
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
